<template>
  <v-row class="widget-container m-r-0 m-l-0" :style="borderStyle">
    <v-col cols="5" class="padding0">
      <div class="text-right">
        <v-icon class="icon-circle" :style="backgroundStyle">{{ icon }}</v-icon>
      </div>
    </v-col>
    <v-col cols="7" class="padding0">
      <div v-if="loading" class="text-running">...</div>
      <div v-else>
        <animated-number
          class="text-running"
          :value="value"
          :formatValue="formatToPrice"
          :duration="1500"
        />
        <span v-if="suffix" class="text-running">{{ suffix }}</span>
      </div>
      <div class="description weight-500" v-html="title"></div>
    </v-col>
  </v-row>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
export default {
  components: {
    AnimatedNumber
  },
  props: ['color', 'icon', 'title', 'value', 'loading', 'suffix', 'fixed'],
  // watch: {
  //   loading: {
  //     immediate: true,
  //     handler() {
  //       console.log(this.loading)
  //     }
  //   }
  // },
  computed: {
    borderStyle() {
      return {
        alignItems: 'center !important',
        borderRadius: '4px'
      }
    },
    backgroundStyle() {
      return {
        background: `${this.color} !important`
      }
    }
  },
  methods: {
    formatToPrice(value) {
      if (this.fixed) return value.toFixed(this.fixed)

      const nf = new Intl.NumberFormat('en-US') // commas, US format
      return nf.format(value.toFixed(0)) // hide fractions
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-container {
  justify-content: center;
  align-items: center;
  font-size: 18px;
  margin: 10px 0;

  .icon-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    vertical-align: middle;
    margin-right: 25px;
    font-size: 40px;
    color: white !important;
  }

  .text-running {
    color: #555555;
    font-weight: 800;
    font-size: 50px;
  }

  .description {
    margin-top: -10px;
  }
}
</style>
